<template>
  <div>
    <customModal v-if="modalComments" v-show="modalComments" :onModalClose="onModalClose" :onModalAccept="saveComment"
                 :modalData="modalComments">
      <div slot-scope="slotProps">
        <div v-if="modalComments.detail.comments && modalComments.detail.comments.length">
          <div class="text-left modal_comment_block" v-for="comment in modalComments.detail.comments">
            <p>{{ comment.text }}</p>
            <p class="text-muted">{{ comment.user_name }} ({{ printDate(comment.date) }})</p>
          </div>
        </div>
        <hr>
        <div>
          <input type="text" v-model="modalComments.new_comment" placeholder="Ваш комментарий" class="form-control">
        </div>
      </div>
    </customModal>

    <button @click="openCommentBlock(detail)" class="btn btn-default comments_btn" type="button">
      <i class="icon-fa icon-fa-comments-o text-center"/>
      <span v-if="detail.comments && detail.comments.length"
            class="badge badge-info">{{ detail.comments.length }}</span>
    </button>
  </div>
</template>

<script>

import customModal from "@/components/modals/customModal";
import api from "@/api";

export default {
  props: ['detail', 'invoice', 'updateRecord'],
  components: {
    customModal,
  },
  data() {
    return {
      modalComments: null,
    }
  },
  methods: {
    onModalClose() {
      this.modalComments = null;
    },
    async saveComment() {
      if (!this.modalComments.new_comment) {
        this.modalComments = null;
        return;
      }
      const {data} = await api.post('invoices/updateByAction', {
        invoice_id: this.invoice.id,
        action: 'drug_comment',
        drug_id: this.modalComments.detail?.drug?.id,
        record_id: this.detail.id,
        comment: this.modalComments.new_comment
      })
      if (data.success) {
        toastr['success'](data.message || 'Сохранено');
        if (this.updateRecord) {
          this.updateRecord({comments: data.response_data});
        }
        this.detail.comments = data.response_data;
        this.onModalClose();
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    },
    openCommentBlock(detail) {
      this.modalComments = {
        acceptBtnText: 'Сохранить',
        header: 'Комментарий к препарату ' + (detail?.drug?.title ?? 'НЕ ВЫБРАН'),
        detail
      };
    },
  }
}

</script>

<style scoped>
.modal_comment_block .text-muted {
  font-size: 10px;
}
</style>
